const tl = {
  // Navbar
  nav_home: "Tahanan",
  nav_about: "Tungkol kay Tito Tenten",
  nav_services: "Serbisyo at Presyo",
  nav_flow: "Proseso",
  nav_testimonials: "Mga Testimonya",
  nav_faq: "FAQ",
  nav_contact: "Makipag-ugnayan",
  nav_cta: "Mag-book ng Konsultasyon sa Pangalan",
  nav_subtitle: "Konsultasyon sa Pangalan · Okinawa",
  nav_title: "Opisina ni Tito Tenten",

  // Hero
  hero_headline1: "Sa gitna ng katahimikan",
  hero_headline2: "ng pulo ng Okinawa",
  hero_headline3: "nakikinig kami",
  hero_headline4: "sa tinig ng inyong pangalan",
  hero_body: "Ang iskedyul ng konsultasyon ay madalas na puno nang maraming buwan bago\nBawat buwan ay personal akong pumupunta sa pulo ng Okinawa\nupang ihatid ang inyong pangalan sa guro",
  hero_pill1: "Walang pagpapalit ng pangalan",
  hero_pill2: "100% online",
  hero_pill3: "Resulta sa loob ng 1 buwan",
  hero_pill4: "100 puwesto bawat buwan",
  hero_btn_apply: "Mag-book ng Konsultasyon sa Pangalan",
  hero_btn_services: "Tingnan ang Serbisyo",
  hero_scroll: "Mag-scroll pababa",

  // About
  about_heading: "Tungkol kay Tito Tenten",
  about_intro: "Sa <strong>Pulo ng Ikei</strong> na tahimik sa gitna ng mainit na dagat ng Okinawa\nmay isang lalaking nagpapaliwanag ng maliit na ilaw para sa bawat pangalan\nMahal na tinatawag siya ng mga tao na <strong>\"Tito Tenten\"</strong>",
  about_block1_label: "Mula sa empleyado ng bangko hanggang eksperto sa pangalan",
  about_block1_text: "Si Tito Tenten ay dating empleyado ng bangko\nSa pamamagitan ng kanyang kasipagan, naging <strong>pinakabatang branch manager</strong> siya sa kumpanya\nSa maraming pagkakataon ng pakikipagtagpo sa mga tao, isang tanong ang lumitaw sa kanyang puso",
  about_block1_quote: "\"Bakit ang ilang tao ay tila may hangin na nagtutulak sa kanila pasulong kahit magkapareho ang pagsisikap?\"",
  about_block1_sub: "Ang maliit na tanong na iyon ay naging simula ng isang malaking pagtuklas",
  about_block2_label: "Sinaunang karunungan at liwanag ng kapayapaan",
  about_block2_text: "Inilaan niya ang lahat ng kanyang libreng oras sa pag-aaral ng mga sinaunang libro tungkol sa konsultasyon sa pangalan, maingat na pinag-aralan ang tradisyonal na Kanji at daloy ng tunog",
  about_block2_text2: "Natuklasan niya na <strong>\"ang tanda ng tenten ay malambing na makakaayos ng daloy ng pangalan\"</strong>",
  about_block2_sub: "Hindi ito dramatikong mahika, hindi ito kahanga-hangang formula ng tagumpay\nKundi isang malambot na landas na tumutulong sa liwanag sa loob ninyo na lumabas nang mas maliwanag",
  about_block3_label: "Salita sa salita — Naghihintay na ng 6 na buwan",
  about_block3_text: "Ang init ng kanyang paraan ng konsultasyon ay kumalat sa pamamagitan ng salita sa salita, at ngayon ay <strong>patuloy na dumarating ang mga tanong mula sa lahat ng sulok nang walang tigil</strong>\nTinatrato niya ang lahat ng tao nang may parehong puso, sikat man o hindi\nInilalagay ang kamay sa bawat pangalan at sinasamahan ang buhay ng bawat isa\nIyan ang paraan ni Tito Tenten",

  // Gallery
  gallery_heading: "Galeria ng Larawan",
  gallery_sub: "Okinawa · Pulo ng Ikei",

  // Services
  services_heading: "Serbisyo at Presyo",
  services_note1: "※ Lahat ng pakete ay kasama na ang bayad sa konsultasyon ng guro at bayad sa kinatawan",
  services_note2: "※ Walang karagdagang bayad, maaari kayong mapanatag",
  services_tab1: "Personal na Pangalan",
  services_tab2: "Pangalan ng Negosyo",
  services_tab3: "Pangalan ng Alagang Hayop",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "Malambing naming isinasaalang-alang ang inyong pag-unlad, kapaligiran, at kilos ng kaluluwa, pagkatapos ay idinaragdag ang pinaka-angkop na tanda ng tenten",
  services_tab2_desc: "Nagdadala ng sariwang hangin para sa bagong hamon, malambing na inaayos ang daloy ng inyong negosyo",
  services_tab3_desc: "Para sa miyembro ng pamilya na laging kasama ninyo, bigyan ng pangalang puno ng kapayapaan at init",
  services_row1_target1: "16 taong gulang pataas",
  services_row1_target2: "4-15 taong gulang",
  services_row1_target3: "0-3 taong gulang",
  services_row2_target1: "Pangalan ng brand / Kumpanya / Tindahan",
  services_row3_target1: "Pangalan ng alagang hayop",
  services_col_target: "Target",
  services_col_price: "Presyo (kasama na ang buwis)",
  services_cta: "I-book ang serbisyong ito",
  services_includes_title: "Kasama sa presyo (lahat)",
  services_inc1: "Konsultasyon sa pangalan",
  services_inc2: "Pinakamainam na mungkahi ng tanda ng tenten",
  services_inc3: "Pagpapadala ng card na sukat ng business card (libre kung gusto)",
  services_inc4: "Payo sa kapalaran",
  services_inc5: "Digital na larawan ng card ng pangalan",
  services_includes_note: "Ang layunin ng konsultasyon ay malambing na gisingin ang mahika na mayroon na sa inyong pangalan",
  services_payment_title: "Paraan ng pagbabayad",
  services_payment_method: "Bank transfer (bayad nang maaga)",
  services_payment_desc: "Pagkatapos mag-rehistro, ibibigay namin ang impormasyon ng bank account\nKapag nakumpleto ang pagbabayad, ang daloy ng kapalaran ay magsisimulang mag-ipon nang tahimik",
  services_first_title: "Para sa unang beses",
  services_first_desc: "Normal ang pakiramdam ng pag-aalangan\nAng pakiramdam na iyon ay isang senyal mula sa loob\nna panahon na para magsimula ng malambot na pagbabago",
  services_first_cta: "Magsimula sa konsultasyon",

  // Flow
  flow_heading: "Proseso ng Serbisyo",
  flow_step1_title: "Magpadala ng form",
  flow_step1_c1: "Punan ang kinakailangang impormasyon sa espesyal na form",
  flow_step1_c2: "Tutugon kami sa loob ng 2-3 araw ng trabaho pagkatapos ng pagpapadala",
  flow_step1_c3: "Ang email ay maglalaman ng mga susunod na hakbang at tagubilin sa paglilipat",
  flow_step2_title: "Ilipat ang bayad sa konsultasyon",
  flow_step2_c1: "Ilipat ang bayad sa konsultasyon sa account na tinukoy sa reply na email",
  flow_step2_c2: "Pagkatapos ng kumpirmasyon ng pagbabayad, magsisimula kaming maghanda ayon sa pagkakasunod",
  flow_step3_title: "Kumpirmasyon ng paglilipat",
  flow_step3_c1: "Pagkatapos ng paglilipat, magpadala ng larawan ng resibo sa address na tinukoy sa email",
  flow_step3_c2: "Pagkatapos ng kumpirmasyon, magpapadala kami ng mensaheng \"Kumpleto na ang pagpaparehistro\"",
  flow_step3_note: "Kung wala ang kumpirmasyon na ito, hindi namin maaaring simulan ang konsultasyon. Tiyaking ipadala ito",
  flow_step4_title: "Tanggapin ang resulta ng konsultasyon",
  flow_step4_c1: "Pagkatapos makumpleto ang konsultasyon, magpapadala kami ng larawan ng card ng pangalan at tanda ng tenten sa pamamagitan ng email sa loob ng isang linggo",
  flow_step4_c2: "Pagkatapos ay magpapadala ng detalyadong ulat ng konsultasyon at payo sa kapalaran sa pamamagitan ng email",
  flow_step5_title: "Pagpapadala ng card ng pangalan (opsyonal)",
  flow_step5_c1: "Kung gusto, magpapadala kami ng card na sukat ng business card na isinulat ng guro sa pamamagitan ng koreo",
  flow_step5_c2: "Mangyaring punan ang tamang address ng koreo sa kolum ng address ng form",
  flow_step5_note: "Kung hindi kailangan ang card, punan lamang ang pangalan ng lungsod kung saan kayo nakatira",
  flow_banner_title: "Lahat ay online, mula sa kahit saan sa Japan",
  flow_banner_desc: "Hindi na kailangang pumunta nang personal sa Pulo ng Ikei sa Okinawa\nMaaari kayong magsimula agad nang hindi binabago ang pang-araw-araw na gawain",
  flow_banner_cta: "Mag-rehistro ngayon",

  // Testimonials
  testimonials_heading: "Mga Testimonya mula sa mga Kliyente",
  testimonials_viewing: "Kasalukuyang tinitingnan",

  // FAQ
  faq_heading: "Mga Madalas na Itanong",
  faq_cta_title: "May iba pa bang tanong?",
  faq_cta_desc: "Malugod naming tinatanggap ang maliliit na tanong\nAng tanong na maaaring mahiyang itanong — iyon ang pinaka-gusto naming marinig",
  faq_cta_btn: "Magtanong",

  // CTA Banner
  cta_heading1: "Libre",
  cta_heading2: "Konsultasyon",
  cta_btn: "Mag-book ngayon",

  // Contact
  contact_heading: "Makipag-ugnayan",
  contact_desc: "Magpadala ng kahilingan sa konsultasyon ng pangalan o tanong sa pamamagitan ng form na ito. Karaniwang tumutugon kami sa loob ng 2-3 araw ng trabaho",
  contact_address_label: "Address",
  contact_address_value: "Tochigi, Japan (Online · Naglilingkod sa buong bansa)",
  contact_email_label: "Email",
  contact_hours_label: "Oras ng trabaho",
  contact_hours_value: "Lun–Biy 9:00–18:00 (Sarado Sab/Lin/pista opisyal)",
  contact_note_title: "Tungkol sa tugon",
  contact_note_desc: "Ang tugon ay maaaring mapunta sa spam folder\nKung hindi nakatanggap ng tugon sa loob ng 2-3 araw ng trabaho, mangyaring makipag-ugnayan nang direkta sa pamamagitan ng email",
  contact_field_name: "Buong pangalan",
  contact_field_furigana: "Furigana (paraan ng pagbabasa ng pangalan)",
  contact_field_email: "Email address",
  contact_field_phone: "Numero ng telepono",
  contact_field_service: "Nais na serbisyo",
  contact_field_message: "Mensahe",
  contact_placeholder_name: "Juan dela Cruz",
  contact_placeholder_furigana: "ヤマダ タロウ",
  contact_placeholder_email: "example@mail.com",
  contact_placeholder_phone: "+63 000 000 0000",
  contact_placeholder_message: "Mangyaring ilagay ang pangalang nais na ikonsulta o ang inyong mga tanong at kahilingan",
  contact_select_placeholder: "Pumili",
  contact_service1: "Personal na pangalan",
  contact_service2: "Pangalan ng negosyo",
  contact_service3: "Pangalan ng alagang hayop",
  contact_service4: "Iba pa / Magtanong pa",
  contact_submit: "Ipadala",
  contact_submitting: "Nagpapadala...",
  contact_privacy: "Ang personal na impormasyon na ipinadala sa pamamagitan ng form ay ginagamit lamang para sa serbisyo ng konsultasyon sa pangalan",
  contact_error: "Nabigo ang pagpapadala. Mangyaring subukan muli mamaya o makipag-ugnayan nang direkta sa pamamagitan ng email",
  contact_err_name: "Mangyaring ilagay ang inyong buong pangalan",
  contact_err_email_required: "Mangyaring ilagay ang inyong email address",
  contact_err_email_invalid: "Mangyaring ilagay ang wastong email address",
  contact_err_service: "Mangyaring pumili ng serbisyo",
  contact_err_message_required: "Mangyaring ilagay ang mensahe",
  contact_err_message_limit: "Ang mensahe ay hindi dapat lumampas sa 500 karakter",
  contact_thanks_title: "Naipadala na ang mensahe",
  contact_thanks_desc: "Salamat sa pakikipag-ugnayan\nPagkatapos suriin ang inyong mensahe, tutugon kami sa loob ng <strong>2-3 araw ng trabaho</strong>\nMangyaring maghintay",
  contact_thanks_check1: "Suriin ang confirmation email",
  contact_thanks_check2: "Suriin din ang spam folder",
  contact_thanks_check3: "Maghintay ng tugon sa loob ng 2-3 araw ng trabaho",
  contact_thanks_another: "Magpadala ng isa pang mensahe",

  // Footer
  footer_subtitle: "Konsultasyon sa Pangalan · Okinawa",
  footer_title: "Opisina ni Tito Tenten",
  footer_desc: "Mula sa Okinawa hanggang sa buong bansa, ang eksperto sa konsultasyon ng pangalan na may higit sa 50 taon ng karanasan ay maingat na binabasa ang kapalaran na nakatago sa inyong pangalan",
  footer_contact_title: "Impormasyon sa Pakikipag-ugnayan",
  footer_address_label: "Address",
  footer_address_value: "Tochigi, Japan\n(Online · Naglilingkod sa buong bansa)",
  footer_email_label: "Email",
  footer_hours_label: "Oras ng trabaho",
  footer_hours_value: "Lun–Biy 9:00–18:00\n(Sarado Sab/Lin/pista opisyal)",
  footer_nav_title: "Nabigasyon",
  footer_copyright: "© 2025 Opisina ni Tito Tenten. Lahat ng karapatan ay nakalaan",
  footer_privacy: "Patakaran sa Privacy",
  footer_law: "Batas sa Espesyal na Kalakalan",
  footer_sitemap: "Mapa ng Site",
};

export default tl;
